import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface DeletePlanConfirmationModalProps {
  open: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
}

export default function DeletePlanConfirmationModal({
  open,
  onClose,
  onConfirm,
}: DeletePlanConfirmationModalProps) {
  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle color="#F00F00" fontWeight={700} fontSize="20px" p="16px">
        Delete plan
      </DialogTitle>
      <DialogContent>
        <Typography color="#525F81" fontWeight={400} fontSize="14px">
          Are you sure? This will permanently remove the selected plan.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          onClick={() => onClose(false)}
          sx={{
            background: '#f0f0f3',
            color: '#60646C',
            borderRadius: '4px',
            width: '66px',
            '&:hover': {
              background: '#dcdcdf',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          sx={{
            background: '#E5484D',
            color: 'white',
            borderRadius: '4px',
            width: '66px',
            '&:hover': {
              background: '#cd4348',
            },
          }}
          onClick={onConfirm}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
